import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext";
import { Modal } from "react-bootstrap";
import InfrastructureImg       from "../images/categories/infrastructure.jpg";
import CanteenImg              from "../images/categories/canteen.jpg";
import ExaminationImg          from "../images/categories/examination.jpg";
import FeePaymentsImg          from "../images/categories/fee-payments.jpg";
import HostelFoodImg           from "../images/categories/hostel-food.jpg";
import EventsImg               from "../images/categories/events.jpg";
import SecurityImg             from "../images/categories/security.jpg";
import SportsImg               from "../images/categories/sports.jpg";
import HousekeepingImg         from "../images/categories/housekeeping.jpg";
import AcademicsImg            from "../images/categories/academics.jpg";
import AudioVisualImg          from "../images/categories/audio-visual.jpg";
import ParkingImg              from "../images/categories/parking.jpg";
import TransportImg            from "../images/categories/transport.jpg";
import LibraryImg              from "../images/categories/library.jpg";
import ITNetworkingImg         from "../images/categories/it-networking.jpg";
import OthersImg               from "../images/categories/others.jpg";
import {
  CheckCircleFill,
  Send,
  PersonFill,
  TagFill,
  FileTextFill,
  ImageFill,
  ChevronDown,
  ChevronUp,
  ExclamationTriangleFill,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import "./ComplaintForm.css";
import { suggestCategory } from "../../utils/categorySuggester";
import { isExperimental } from "../../utils/isExperimental";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DuplicateComplaintModal from "../DuplicateComplaints/Duplicatecomplaintmodal"; // NEW

const CATEGORY_DEFAULT_IMAGES = {
  "Infrastructure":             InfrastructureImg,
  "Canteen":                    CanteenImg,
  "Examination":                ExaminationImg,
  "Academics":                  AcademicsImg,
  "Fee Payments and Accounts":  FeePaymentsImg,
  
  "Hostel Food":                HostelFoodImg,
  "Extracurricular and Events": EventsImg,
  "Security":                   SecurityImg,
  "Sports":                     SportsImg,
  "Housekeeping":               HousekeepingImg,
  "Audio-Visual Equipment":     AudioVisualImg,
  "Parking":                    ParkingImg,
  "Transport":                  TransportImg,
  "Library":                    LibraryImg,
  "IT and Networking":          ITNetworkingImg,
  "Others":                     OthersImg,
};




const categoriesList = [
  { name: "Infrastructure", icon: "🏗" },
  { name: "Canteen", icon: "🍽" },
  { name: "Examination", icon: "📖" },
  { name: "Academics", icon: "📚" },
  { name: "Fee Payments and Accounts", icon: "💳" },
  {name: "EduPrime", icon: "🎓" },
  { name: "Hostel Food", icon: "🍲" },
  { name: "Extracurricular and Events", icon: "🏆" },
  { name: "Security", icon: "🛡" },
  { name: "Sports", icon: "⚽" },
  { name: "Housekeeping", icon: "🧹" },
  { name: "Audio-Visual Equipment", icon: "🎥" },
  { name: "Parking", icon: "🚗" },
  { name: "Transport", icon: "🚌" },
  { name: "Library", icon: "📚" },
  { name: "IT and Networking", icon: "💻" },
  { name: "Others", icon: "📦" },
];

const ComplaintForm = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    category: "",
    description: "",
    location: "",
    connectionType: "",
    department: "",
    name: "",
    room_number: "",
    internet_speed: "",
    mobile_number: "",
    issue_duration: "",
  });


  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [warning, setWarning] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [duplicateComplaint, setDuplicateComplaint] = useState(null);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false); // NEW
  const [showSizeError, setShowSizeError] = useState(false);

  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const displayedCategories = showAll ? categoriesList : categoriesList.slice(0, 7);
  const baseUrl = process.env.REACT_APP_COMPLAINTS_APP_BE_URL;


  const [suggestedCategories, setSuggestedCategories] = useState([]);




  const normalizedCategory = typeof formData.category === "string" ? formData.category.trim().toLowerCase() : "";
  const isITCategory = [
    "it and networking",
    "it & networking",
    "it networking",
    "it/networking",
  ].includes(normalizedCategory);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedData = { ...formData, [name]: value };
    setFormData(updatedData);

    // Auto suggest category when typing title or description
    if (name === "title" || name === "description") {
      const suggestions = suggestCategory(
        updatedData.title,
        updatedData.description
      );

      setSuggestedCategories(suggestions);
    }

  };
   
   


  const handleCategorySelect = (cat) => {
    setFormData({
      ...formData,
      category: cat,
      location: "",
      connectionType: "",
      department: "",
      name: "",
      room_number: "",
      internet_speed: "",
      mobile_number: "",
      issue_duration: "",
    });
  
    setShowAll(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 15000 * 1024) {
        setShowSizeError(true);
        return;
      }
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // Extracted so it can be called both from the normal submit flow and from
  // the "No, my complaint is different" button inside the duplicate modal.
 const submitComplaint = async ({ bypassDuplicateCheck = false } = {}) => {
  setLoading(true);
  setMessage("");
  setWarning("");

  // Check login
  if (!user) {
    setMessage("You must be logged in to submit a complaint.");
    setLoading(false);
    return;
  }

  // Check category
  if (!formData.category) {
    setWarning("Please choose a suitable category for your request.");
    setLoading(false);
    return;
  }

  try {
    // Default category image
    let imageUrl =
      CATEGORY_DEFAULT_IMAGES[formData.category] ||
      CATEGORY_DEFAULT_IMAGES["Others"];

    // Upload user image if provided
    if (image && !bypassDuplicateCheck) {
      const imgData = new FormData();

      imgData.append("file", image);
      imgData.append("upload_preset", "complaint_uploads");

      const uploadRes = await axios.post(
        "https://api.cloudinary.com/v1_1/dbsrpikci/image/upload",
        imgData
      );

      imageUrl = uploadRes.data.secure_url;
    }

    // Check IT & Networking category
    const normalizedCategory =
      typeof formData.category === "string"
        ? formData.category.trim().toLowerCase()
        : "";

    const isITCategory = [
      "it and networking",
      "it & networking",
      "it networking",
      "it/networking",
    ].includes(normalizedCategory);

    // IT & Networking validation
    if (isITCategory) {
      if (!formData.connectionType) {
        setWarning(
          "Please select Connection Type for IT & Networking complaints."
        );
        setLoading(false);
        return;
      }

      if (
        !formData.room_number ||
        !formData.internet_speed ||
        !formData.mobile_number ||
        !formData.issue_duration
      ) {
        setWarning(
          "Please fill all IT & Networking fields: Room Number, Internet Speed, Mobile Number and Issue Duration."
        );
        setLoading(false);
        return;
      }
    }

    // Complaint data
    const complaintData = {
      complaint_id: Date.now().toString(),
      title: formData.title,
      category: formData.category,
      description: formData.description,
      user_id: user?.email,
      image: imageUrl,

      ...(isITCategory
        ? {
            it_details: {
              // location: formData.location,
              connectionType: formData.connectionType,
              name: formData.name,
              department: formData.department,
              room_number: formData.room_number,
              internet_speed: formData.internet_speed,
              mobile_number: formData.mobile_number,
              issue_duration: formData.issue_duration,
            },
          }
        : {}),

      ...(bypassDuplicateCheck
        ? { bypass_duplicate_check: true }
        : {}),
    };

    // Authentication token
    const token = localStorage.getItem("authToken");

    console.log("Submitting complaint:", complaintData);

    // Send complaint to backend
    const response = await axios.post(
      `${baseUrl}/user-api/add-complaint`,
      complaintData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Success
    if (response.status === 201) {
      setShowSuccess(true);
      setDuplicateComplaint(null);
      setShowDuplicateModal(false);

      setFormData({
        title: "",
        category: "",
        description: "",
        location: "",
        connectionType: "",
        name: "",
        department: "",
        room_number: "",
        internet_speed: "",
        mobile_number: "",
        issue_duration: "",
      });

      setImage(null);
      setImagePreview(null);

      setTimeout(() => {
        setShowSuccess(false);
        navigate("/all-complaints");
      }, 3000);

      if (isExperimental) {
        toast.info(
          "📧 Experimental Mode: Simulating email to Admin...",
          {
            autoClose: 3000,
            position: "top-center",
          }
        );
      }
    } else {
      setMessage(
        "Failed to register complaint. Please try again."
      );
    }
  } catch (error) {
    console.error(
      "Error submitting complaint:",
      error.response?.data || error.message
    );

    // Duplicate complaint
    if (error.response?.status === 409) {
      setDuplicateComplaint(error.response.data);
      setShowDuplicateModal(true);
      setMessage("");
      setWarning("");
    }

    // Bad request
    else if (error.response?.status === 400) {
      setWarning(
        error.response.data.message ||
          "Invalid complaint details."
      );
    }

    // Other errors
    else {
      setMessage(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong."
      );
    }
  }

  setLoading(false);
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitComplaint();
  };

  // ---------------- NEW: duplicate modal handlers ----------------
  const handleSupportedExistingComplaint = () => {
    // Student confirmed "Yes, same issue" — support call already made inside the modal.
    setShowDuplicateModal(false);
    setDuplicateComplaint(null);
    // Reset the form since they're not filing a new complaint after all.
    setFormData({ title: "", category: "", description: "", location: "", connectionType: "",name: "",department: "",room_number: "", internet_speed: "", mobile_number: "", issue_duration: "" });
    setImage(null);
    setImagePreview(null);
   
    navigate("/all-complaints");
  };

  const handleRegisterAnyway = () => {
    setShowDuplicateModal(false);
    submitComplaint({ bypassDuplicateCheck: true });
  };
  // ------------------------------------------------------------

  const headingStyle = {
    fontSize: "2.3rem",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "25px",
    fontFamily: "serif",
    color: "black",
  };

  const userInfoStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "25px",
  };

  const avatarStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #007bff",
  };

  const labelStyle = {
    fontWeight: "600",
    fontSize: "15px",
    marginBottom: "8px",
    color: "#f5eeeeff",
  };

  const lightBlue = "#4da6ff";

  return (
    <div className="complaint-container">
      <ToastContainer />
      <h2 style={headingStyle}>Register a Complaint</h2>

      <form className="form" onSubmit={handleSubmit}>
        <div style={userInfoStyle}>
          <img
            src={user?.picture || "/default-avatar.png"}
            alt="User Avatar"
            style={avatarStyle}
          />
          <span style={{ fontSize: "20px", color: "#f9f3f3ff", fontFamily: "serif" }}>
            {user?.name}
          </span>
        </div>

        <div className="input-group">
          <label style={labelStyle}>
            <span className="label-icon purple me-2">
              <i className="bi bi-info-lg"></i>
            </span>
            {" "}
            Request Title *
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Enter a clear, descriptive title..."
            required
          />
        </div>

        {suggestedCategories.length > 0 && !formData.category && (
          <div className="suggested-wrapper">
            <div className="suggested-header">
              💡 Suggested categories
            </div>

            <div className="suggested-pills">
              {suggestedCategories.map((cat) => (
                <button
                  key={cat}
                  type="button"
                  className="suggested-pill"
                  onClick={() => handleCategorySelect(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="suggested-hint">
              (optional – you can change this)
            </div>
          </div>
        )}

        <div className="input-group">
          <div className="category-label-wrapper">
            <label style={labelStyle}>
              <span className="label-icon orange me-2">
                <i className="bi bi-tag"></i>
              </span>
              {" "}
              Category
            </label>
          </div>
          <div className="category-grid">
            {formData.category ? (
              <div className="category-btn active selected-category-card">
                <span className="icon">
                  {categoriesList.find((c) => c.name === formData.category)?.icon}
                </span>
                <span className="cat-name">{formData.category}</span>

                <button
                  type="button"
                  className="close-btn-inside"
                  onClick={() => {
                    setFormData({ ...formData, category: "" });
                    setShowAll(true);
                  }}
                >
                  ×
                </button>
              </div>
            ) : (
              <>
                {displayedCategories.map((cat) => (
                  <button
                    key={cat.name}
                    type="button"
                    className={`category-btn ${formData.category === cat.name ? "active" : ""}`}
                    onClick={() => handleCategorySelect(cat.name)}
                  >
                    <span className="icon">{cat.icon}</span>
                    <span>{cat.name}</span>
                  </button>
                ))}

                <button
                  type="button"
                  className="category-btn more-btn"
                  onClick={() => setShowAll(!showAll)}
                >
                  <span className="icon-circle">
                    {showAll ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </span>
                  {showAll ? "Show Less" : "More Options"}
                </button>
              </>
            )}
          </div>
        </div>

        <div className="input-group">
          <label style={labelStyle}>
            <span className="label-icon dark-purple me-2">
              <i className="bi bi-card-text"></i>
            </span>
            {" "}
            Detailed Description *
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Please provide a comprehensive description of your issue..."
            rows="5"
            required
          />
        </div>

       

            {isITCategory && (
  <div className="it-fields">

   <p
  className="complaint-note mt-3 d-flex align-items-start"
  style={{
    justifyContent: "flex-start",
    textAlign: "left",
    width: "100%",
    marginLeft: "0"
  }}
>
  <i className="bi bi-info-circle-fill text-info"></i>
  <span className="ms-2">
        For IT & Networking complaints, provide your contact information
      for faster resolution.
      </span>
    </p>

    {/* <div className="input-group"></div>

           
            <div className="input-group">
              <label style={labelStyle}>Location *</label>

              <select
                name="location"
                value={formData.location}
                onChange={handleChange}
                className="styled-select"
                required
              >
                <option value="">-- Select Location --</option>
                <option value="Main Campus">Main Campus</option>
               
                
              </select>
            </div> */}

            {/* CONNECTION TYPE */}
           
              <div className="input-group">
                <label style={labelStyle}>Connection Type *</label>

                <select
                  name="connectionType"
                  value={formData.connectionType}
                  onChange={handleChange}
                  className="styled-select"
                  required
                >
                  <option value="">-- Select Connection --</option>
                  <option value="WiFi">WiFi</option>
                  <option value="LAN">LAN</option>
                </select>
              </div>
            
            {/* DEPARTMENT */}
<div className="input-group">
  <label style={labelStyle}>Department *</label>

  <input
    type="text"
    name="department"
    value={formData.department}
    onChange={handleChange}
    placeholder="Enter your department"
    required
  />
</div>
{/* NAME */}
<div className="input-group">
  <label style={labelStyle}>Name *</label>

  <input
    type="text"
    name="name"
    value={formData.name}
    onChange={handleChange}
    placeholder="Enter your name"
    required
  />
</div>

    
           
            {/* ROOM NUMBER */}
    <div className="input-group">
      <label style={labelStyle}>Room Number *</label>

      <input
        type="text"
        name="room_number"
        value={formData.room_number}
        onChange={handleChange}
        placeholder="e.g. B-204 or Lab-A"
        required
      />
    </div>

                <div className="input-group">
                  <label style={labelStyle}>Internet Speed *</label>
                  <input
                    type="text"
                    name="internet_speed"
                    value={formData.internet_speed || ""}
                    onChange={handleChange}
                    placeholder="e.g. 0.5 Mbps or 10 Mbps"
                    required
                  />
                </div>

                <div className="input-group">
                  <label style={labelStyle}>Mobile Number *</label>
                  <input
                    type="tel"
                    name="mobile_number"
                    value={formData.mobile_number || ""}
                    onChange={handleChange}
                    placeholder="e.g. 9876543210"
                    required
                  />
                </div>

                <div className="input-group">
                  <label style={labelStyle}>Issue Duration *</label>
                  <input
                    type="text"
                    name="issue_duration"
                    value={formData.issue_duration || ""}
                    onChange={handleChange}
                    placeholder="e.g. 2 hours, since yesterday"
                    required
                  />
                </div>
              

          </div>
        )}


      
          <div className="input-group image-upload-container">
            <div className="upload-label">
              <label>
                <span className="label-icon blue me-2">
                  <i className="bi bi-image"></i>
                </span>
                Upload Image (Optional)
              </label>
            </div>

            <div className="upload-box-wrapper">
              <div className="upload-box">
                {!imagePreview ? (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="file-input"
                      id="file-upload"
                      style={{ display: "none" }}
                    />
                    <label htmlFor="file-upload" className="upload-placeholder">
                      <div className="upload-icon">
                        ⬆️
                        <div className="upload-line"></div>
                      </div>
                      <span className="upload-text">Upload Image</span>
                    </label>
                  </>
                ) : (
                  <div className="image-preview">
                    <img src={imagePreview} alt="Preview" />
                    <button
                      type="button"
                      className="remove-btn"
                      onClick={() => {
                        setImage(null);
                        setImagePreview(null);
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}
              </div>
              <p className="file-size-note m-2">Preferred size: ≤ 1.5MB</p>
            </div>
          </div>
       

        <p className="complaint-note mt-3 d-flex align-items-start no-padding-left">
          <i className="bi bi-exclamation-triangle-fill text-warning"></i>
          <span className="warningred ms-2">
            False or invalid requests are strictly prohibited. Only genuine issues will be considered.
          </span>
        </p>

        <button type="submit" className="submit-btn" disabled={loading}>
          <Send style={{ marginRight: "8px", verticalAlign: "middle" }} size={18} color="#fff" />
          {loading ? "Submitting..." : "Register Request"}
        </button>

        {warning && (

          <p className="form-warning mt-3">
            <span className="text-danger">⚠</span>{" "}
            <span className="text-white">{warning}</span>
          </p>
        )}

        {message && <p className="form-message">{message}</p>}
      </form>

      {/* NEW: duplicate complaint modal replaces the old inline warning box */}
      <DuplicateComplaintModal
        show={showDuplicateModal}
        complaint={duplicateComplaint?.matchingComplaint}
        similarity={duplicateComplaint?.similarity}
        baseUrl={baseUrl}
        onClose={() => setShowDuplicateModal(false)}
        onSupported={handleSupportedExistingComplaint}
        onRegisterAnyway={handleRegisterAnyway}
      />

      <Modal show={showSuccess} onHide={() => setShowSuccess(false)} centered>
        <Modal.Body className="text-center p-5">
          <CheckCircleFill className="success-icon" />
          <h5 className="text-success">Request Registered Successfully!</h5>
        </Modal.Body>
      </Modal>

      <Modal show={showSizeError} onHide={() => setShowSizeError(false)} centered>
        <Modal.Body className="text-center p-5">
          <ExclamationTriangleFill className="text-danger" size={50} />
          <h5 className="text-danger mt-3">File Too Large!</h5>
          <p>Please upload an image ≤ 1.5MB and try again.</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ComplaintForm;